<template lang="html">

  <article class="actividad-el column-start" >

    <h1 class="titulo"> {{data.name}}</h1>

    <h2 class="hora">
      <template v-for="(n,key) in data.dates">
        {{n.date | fecha}}
      </template>
    </h2>


    <h2 class="lugar">{{data.address}}</h2>
    <h3 v-if="!!data.short_description" class="tipo">{{data.short_description}}</h3>


    <template v-if="show">
      <div class="descripcion">
        
        <editor :object="data.description"></editor>
        <p>Sujeto a disponibilidad</p>
      </div>

      <template v-if="data.dates.every(d => !d.url || d.url.includes('nuevaweb'))">

      <template v-if="data.dates.every(d => d.block == 1)">
        <h3 class="proximamente" v-if="data.dates[0].block_reason == 0">PRÓXIMAMENTE</h3>
        <h3 class="proximamente -red" v-if="data.dates[0].block_reason == 1">ACTIVIDAD SUSPENDIDA POR CIERRE PERIMETRAL</h3>
        <h3 class="proximamente -red" v-if="data.dates[0].block_reason == 2">ACTIVIDAD APLAZADA</h3>
        <h3 class="proximamente -red" v-if="data.dates[0].block_reason == 3">ACTIVIDAD CANCELADA</h3>
      </template>

      <template v-if="data.dates.some(d => d.block == 0) && data.dates.every(d => d.complete)">
        <h3 class="proximamente" v-if="data.dates.every(d => !d.waiting)">COMPLETA</h3>
        <router-link v-else :to="`/registro?name=${data.name}&dateid=${selected}&hour=${hour}&date=${fecha}&bus=${data.bus}`"
        class="btn-skull -green" @click="sendEvent">Inscríbete en la lista de espera ({{hour}})</router-link>
      </template>

      <template v-if="data.dates.some(d => d.block == 0) && data.dates.some(d => !d.complete)">

        <template v-if="data.dates.length != 1">
          <div class="contenedor-radios">
            <h4>Selecciona un horario</h4>
            <div class="radio" v-for="(n,key) in data.dates" :disabled="n.complete || n.block == 1">
              <input type="radio" :name="'horario-'+data.id" :disabled="n.complete || n.block == 1" :value="n.id"
                v-model="selected" :id="data.id+'-'+n.id" @change="setid(n)">
              <label :for="data.id+'-'+n.id">
                {{n.date | fecha}}
                {{(n.complete) ? '(Sin plazas)' : ''}}
                {{(n.block == 1 && n.block_reason == 0) ? '(Proximamente)' : ''}}
                {{(n.block == 1 && n.block_reason == 1) ? '(Actividad aplazada)' : ''}}
                {{(n.block == 1 && n.block_reason == 2) ? '(Actividad cancelada)' : ''}}
              </label>
            </div>
          </div>
        </template>

        <template v-if="selected">
          <router-link :to="`/registro?name=${data.name}&dateid=${selected}&hour=${hour}&date=${fecha}&bus=${data.bus}`"
            class="btn-skull -green" @click="sendEvent">Inscríbete</router-link>
        </template>

      </template>


    </template>

    <template v-else>
      <a :href="data.dates[0].url" target="_blank" class="btn-skull -green">Inscríbete</a>
    </template>



    </template>

    <a @click="show= !show" class="show-more">Ver {{(show) ? 'menos' : 'más'}}</a>

  </article>

</template>

<script lang="js">

  import moment from 'moment';

  import editor from '@/components/parts/editorJs'

  export default {
    name: 'actividad',
    props: ['data'],
    mounted() {
      if (this.data.dates.length == 1) {
        this.selected = this.data.dates[0].id;
        this.hour = this.data.dates[0].date;
      }
    },
    data() {
      return {
        show: false,
        selected: '',
        hour: '',
        fecha: ''
      }
    },
    filters: {
      parseHour(value) {

        let hora = value.split(" ").pop();

        return hora;

      },
      fecha(value){
        moment.locale('es');        
        return moment(value).format('HH:mm');
      }
    },
    methods: {
      sendEvent() {
        gtag('event', 'conversion', {
          'send_to': 'AW-789750121/NJaQCPeWuYkBEOnCyvgC'
        });
      },
      setid(value) {
        this.selected = value.id;
        this.hour = value.date;
      }
    },
    components : {
      'editor': editor
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/parts/actividad-el.vue